import {AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { SegnalazioniRepository } from '../../model/segnalazioni.repository';
import { Submission } from '../../model/submission.model';
import { EnvConfig } from "src/environments/environment";
import { AnyForJSON } from 'formiojs';
import { Health } from '../../model/health.model';
import {ConfirmationService, MessageService} from 'primeng/api';
import { Formio } from 'angular-formio';
import {RecaptchaComponent, RecaptchaErrorParameters} from 'ng-recaptcha';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import {italian} from "../../../assets/i18n/it-IT";
import {english} from "../../../assets/i18n/en-GB";
import {LanguageService} from "../../services/language.service";
import {tap} from "rxjs/operators";
import {AuthService} from "../../services/auth.service";
import {MatomoTracker} from "@ngx-matomo/tracker";
import {Subscription} from "rxjs";

@Component({
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.css'],
  providers: [ConfirmationService,MessageService]
})

export class FormComponent implements OnInit, OnDestroy, AfterViewInit {

  language = new EventEmitter();
  i18n: any;

  myform: any;

  refreshForm = new EventEmitter();

  private jwtToken:string = "";

  private tmpPG!: AnyForJSON;

  options: Object = {
    submitMessage: "",
    disableAlerts: true,
    noAlerts: true,
    saveDraft: true,
  };

  src: string = EnvConfig.appUrl+"/"+EnvConfig.formId;
  versione: string = EnvConfig.version+"_"+EnvConfig.env;
  health: Health = new Health;

  load: string = 'KO';
  saving: string = 'KO';

  data_salvataggio: string = "";

  renderOptions: any = {
    buttonSettings: {
      showCancel: false
    },
    breadcrumbSettings: {
      clickable:false
    },
    language: 'it',
    i18n: {
      it: italian,
      en: english
    }
  }

  formioError: boolean = false;
  captcha: boolean = false;
  captchaResponse = "";

  private subscription: Subscription = new Subscription();

  @ViewChild('captchaRef') captchaRef!: RecaptchaComponent;
  constructor(
    public router:Router,
    public sub: Submission,
    private repository: SegnalazioniRepository,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private http:HttpClient,
    private languageService: LanguageService,
    private authService: AuthService,
    private tracker: MatomoTracker
  ) {
    Formio.setBaseUrl(EnvConfig.appUrl)
    Formio.setProjectUrl(EnvConfig.appUrl+EnvConfig.formId);
  }

  async ngOnInit(): Promise<void> {
    this.languageService.selectedLang$.pipe(
      tap((data) => {
        if (data?.code.slice(0, 2) === 'en') {
          this.renderOptions.i18n.en = english;
          this.i18n = english;
          this.renderOptions.language = 'en';
          this.language.emit('en');
        } else {
          this.renderOptions.i18n.it = italian;
          this.i18n = italian;
          this.renderOptions.language = 'it';
          this.language.emit('it');
        }
      })
    ).subscribe();


    localStorage.removeItem("formioAppUser");
    localStorage.removeItem("formioUser");
    localStorage.removeItem("formioAppRole");
    localStorage.removeItem("formioToken");

    this.myform = await this.http.get<string>(EnvConfig.appUrl+'/'+EnvConfig.formId).toPromise()
        .catch((err: HttpErrorResponse) => {
          this.formioError=true;
        })

    try {
      this.health = (await this.repository.health());

      if (this.health.status === "KO")
      {
        if (this.languageService.lang.slice(0, 2) === 'en') {
          alert("WARNING: Some autocomplete services may not be available\n"+this.health.message+"\n The unavailability of autocomplete services does not prevent the correct submission of the report.");
        } else {
          alert("ATTENZIONE, alcuni servizi di autocompletamento potrebbero non essere disponibili\n"+this.health.message+"\n  L'indisponibilità dei servizi di autocompletamento non preclude il corretto invio della segnalazione.");
        }
      }

    } catch (e) {
      this.health.status = "KO";
      if (this.languageService.lang.slice(0, 2) === 'en') {
        alert("WARNING: Some autocomplete services may not be available\n"+this.health.message+"\n The unavailability of autocomplete services does not prevent the correct submission of the report.");
      } else {
        alert("ATTENZIONE, alcuni servizi di autocompletamento potrebbero non essere disponibili\n"+this.health.message+"\n  L'indisponibilità dei servizi di autocompletamento non preclude il corretto invio della segnalazione.");
      }
    }

    this.jwtToken = (await this.repository.authenticate())?.token;
  }

  ngAfterViewInit() {
    this.captchaRef.execute();
  }

  ngOnDestroy(): void{
    if(this.subscription){
      this.subscription.unsubscribe()
    }
  }

  get healthStatus()
  {
    return this.health;
  }


  async formLoad(event: any): Promise<void> {


    let datisalvati = localStorage.getItem("draft");

    if (datisalvati)
    {
      this.tracker.trackEvent('Bozza', 'Carica bozza');

      let saveDate = localStorage.getItem("date");

      var date1 = new Date(parseInt(""+saveDate));
      var date2 = new Date();

      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

      // se il salvataggio è più vecchio di 10 giorni viene cancellata la local storage
      if (diffDays>9)
      {
        localStorage.clear();
        datisalvati="{}";
      }
      else {
        let data_aux = localStorage.getItem("data_salvataggio");
        this.load = 'OK';
        if (data_aux)
          this.data_salvataggio = data_aux;
      }
    }

    if (datisalvati==null)
    {
      datisalvati="{}";
    }

    event.data = JSON.parse(datisalvati);

    this.subscription = this.authService.userInfo$.subscribe((user) => {
      if (user) {
        event.data.valueSPID = 'true';
        event.data.nome_soggetto_segnalante = user.firstName;
        event.data.cognome_soggetto_segnalante = user.lastName;
        event.data.codiceFiscale_soggetto_segnalante_SSO = user.username;
        event.data.email_soggetto_segnalante = user.email;
        this.myform.components[0].components[1].components[0].components[0].columns[0].components[0].disabled = true
        this.myform.components[0].components[1].components[0].components[0].columns[1].components[0].disabled = true
        this.myform.components[0].components[1].components[0].components[0].columns[2].components[1].disabled = true
        //this.myform.components[0].components[1].components[0].components[1].columns[0].components[0].disabled = true
      }
    })

    this.refreshForm.emit({
      form: this.myform,
      submission: {
        data: event.data
      }
    });

  }

  onTop(): void {
    window.scrollTo(0,0);
  }

  invalid(event: any)
  {
    console.log("invalido");
  }

  private titleCaseWord(word: string) {
    if (!word) return word;
    return word[0].toUpperCase() + word.substr(1).toLowerCase();
  }

  async customEvent(event: any)
  {
    let submissionAux = event.data;

    /* azione per il salvataggio in bozza, nella localstorage, della sottomissione */
    if (event.type === 'salvabozza') {

      this.tracker.trackEvent('Bozza', 'Salva in bozza');

      window.scrollTo(0,0);

      this.saving='OK'

      localStorage.clear();
      localStorage.setItem("draft",JSON.stringify(submissionAux));

      let date = new Date();
      let data_format = String(date.getDate()).padStart(2, '0') + '/' + String(date.getMonth() + 1).padStart(2, '0') + '/' + date.getFullYear();
      let hh = String(date.getHours()).padStart(2, '0');
      let mm = String(date.getMinutes()).padStart(2, '0');

      localStorage.setItem("data_salvataggio",data_format+" "+hh+":"+mm);
      localStorage.setItem("date",""+date.getTime());
    }

    if (event.type === 'cancella_cig'){
      submissionAux.cancella_cig=1;
      submissionAux.cig_trovato=1;
      submissionAux.cig='';

      submissionAux.codiceFiscale_sa='';
      submissionAux.denominazione_sa='';
      submissionAux.regione_appalti='';
      submissionAux.provincia_appalti='';
      submissionAux.comune_appalti='';
      submissionAux.nome_rup='';
      submissionAux.cognome_rup='';
      submissionAux.descrizione_intervento_segnalazione='';
      submissionAux.importo_contrattuale='';
      submissionAux.stazioneappaltante='';

      submissionAux.oggettoContratto_sa='';
      submissionAux.importo_base_asta='';
      submissionAux.ambitodellintervento='';
      submissionAux.procedura_affidamento='';

      submissionAux.data_oe='';
      submissionAux.data_sa='';
      submissionAux.area_vigilanza_appalti='';
    }

    if (event.type === 'cerca_ente_cf'){

      let valcf = submissionAux.cf_amministrazione;
      if (!valcf)
        valcf = submissionAux.cf_amministrazione2;
      if (!valcf)
        valcf = submissionAux.cf_amministrazione_oe;
      if (!valcf)
        valcf = submissionAux.cf_amministrazione_ente_anticorruzione;
      if (!valcf)
        valcf = submissionAux.cf_amministrazione_ente_incarichi;
      if (!valcf)
        valcf = submissionAux.cf_amministrazione_ente_trasparenza;

      console.log("codice_fiscale: "+valcf);

      let response = null;
      try {
        response = (await this.repository.getResponseWaitPG(valcf,this.jwtToken))
      } catch (error) {

      }

      let auxval = `<p class='p-3 mb-2 bg-danger text-dark font-weight-bold'>${this.i18n.cf_non_trovato}</p>`

      if (response)
      {
        auxval = "<ul class='list-group list-group-flush'>"+
                   "<li class='list-group-item'>"+`<b>${this.i18n.denominazione}</b> `+this.clean(response.dati_identificativi.denominazione,'N.D')+"</li>"+
                   "<li class='list-group-item'>"+`<b>${this.i18n.cf}</b> `+this.clean(response.dati_identificativi.codice_fiscale,'N.D.')+"</li>"+
                   "<li class='list-group-item'>"+`<b>${this.i18n.localizzazione}</b> `+
                      this.clean(response.dati_identificativi.localizzazione.citta.nome + " (" +
                                 response.dati_identificativi.localizzazione.provincia.nome + ")",'N.D.')+"</li>"+
                   "<li class='list-group-item'>"+`<b>${this.i18n.natura_giuridica}</b> `+this.clean(response.dati_identificativi.natura_giuridica.descrizione,'N.D.')+"</li>"+
                   "</ul>";

        submissionAux.cf_trovato = "TROVATO";
      }
      else
      submissionAux.cf_trovato = "NON_TROVATO";

      submissionAux.summary_cf = auxval;
      submissionAux.summary_cf2 = auxval;
      submissionAux.summary_cf_oe = auxval;
      submissionAux.summary_cf_ente_anticorruzione = auxval;
      submissionAux.summary_cf_ente_incarichi = auxval;
      submissionAux.summary_cf_ente_trasparenza = auxval;

      this.tmpPG = response;
    }

    if (event.type === 'conferma_selezione_amministrazione_rpct' || event.type === 'conferma_selezione_cf_rpct') {

        submissionAux.denominazione_rpct = this.clean(this.tmpPG.dati_identificativi.denominazione,'N.D.');
        submissionAux.cf_rpct = this.clean(this.tmpPG.dati_identificativi.codice_fiscale,'N.D.');

        let regione =
          (await this.repository.getResponseWaitRegioneFromProvincia(
            this.tmpPG.dati_identificativi.localizzazione.provincia.nome,
            this.tmpPG.dati_identificativi.localizzazione.citta.nome,
            this.jwtToken));

        submissionAux.regione_rpct = regione.nome;

        submissionAux.provincia_rpct = this.titleCaseWord(this.clean(this.tmpPG.dati_identificativi.localizzazione.provincia.nome,''));
        submissionAux.comune_rpct = this.titleCaseWord(this.clean(this.tmpPG.dati_identificativi.localizzazione.citta.nome,''));
        submissionAux.pec_rpct = this.clean(this.tmpPG.dati_identificativi.contatti.MAIL_PEC,'');
        submissionAux.mail_rpct = this.clean(this.tmpPG.dati_identificativi.contatti.EMAIL,'');

        submissionAux.telefono_rpct = this.clean(this.tmpPG.dati_identificativi.contatti.TELEFONO,'');


        if (event.type === 'conferma_selezione_amministrazione_rpct')
        {
          submissionAux.summary_denominazione =
            submissionAux.summary_denominazione.split('list-group-item').join('list-group-item list-group-item-primary');
          submissionAux.cf_amministrazione = "";
        }
        else
        {
          submissionAux.summary_cf =
            submissionAux.summary_cf.split('list-group-item').join('list-group-item list-group-item-primary');
          submissionAux.denominazione_amministrazione = "";
        }
    }

    if (event.type === 'conferma_selezione_amministrazione' || event.type === 'conferma_selezione_cf') {

      submissionAux.denominazione = this.clean(this.tmpPG.dati_identificativi.denominazione,'N.D.');
      submissionAux.cf = this.clean(this.tmpPG.dati_identificativi.codice_fiscale,'N.D.');

      let regione =
        (await this.repository.getResponseWaitRegioneFromProvincia(
          this.tmpPG.dati_identificativi.localizzazione.provincia.nome,
          this.tmpPG.dati_identificativi.localizzazione.citta.nome,
          this.jwtToken));
      submissionAux.regione= (regione.nome);

      submissionAux.provincia = this.titleCaseWord(this.clean(this.tmpPG.dati_identificativi.localizzazione.provincia.nome,''));
      submissionAux.comune = this.titleCaseWord(this.clean(this.tmpPG.dati_identificativi.localizzazione.citta.nome,''));
      submissionAux.pec = this.clean(this.tmpPG.dati_identificativi.contatti.MAIL_PEC,'');
      submissionAux.mail = this.clean(this.tmpPG.dati_identificativi.contatti.EMAIL,'');

      submissionAux.telefono = this.clean(this.tmpPG.dati_identificativi.contatti.TELEFONO,'');


      if (event.type === 'conferma_selezione_amministrazione')
      {
        submissionAux.summary_denominazione2 =
          submissionAux.summary_denominazione2.split('list-group-item').join('list-group-item list-group-item-primary');
        submissionAux.cf_amministrazione2 = "";
      }
      else
      {
        submissionAux.summary_cf2 =
          submissionAux.summary_cf2.split('list-group-item').join('list-group-item list-group-item-primary');
        submissionAux.denominazione_amministrazione2 = "";
      }
  }

  /* OPERATORE ECONOMICO */
  if (event.type === 'conferma_selezione_amministrazione_oe' || event.type === 'conferma_selezione_cf_oe') {

    submissionAux.denominazione_operatoreEconomico = this.clean(this.tmpPG.dati_identificativi.denominazione,'N.D.');
    submissionAux.codiceFiscale_operatoreEconomico = this.clean(this.tmpPG.dati_identificativi.codice_fiscale,'N.D.');

    let regione =
      (await this.repository.getResponseWaitRegioneFromProvincia(
        this.tmpPG.dati_identificativi.localizzazione.provincia.nome,
        this.tmpPG.dati_identificativi.localizzazione.citta.nome,
        this.jwtToken));
    submissionAux.regione_appalti_oe= (regione.nome);

    submissionAux.provincia_appalti_oe = this.titleCaseWord(this.clean(this.tmpPG.dati_identificativi.localizzazione.provincia.nome,''));
    submissionAux.comune_appalti_oe = this.titleCaseWord(this.clean(this.tmpPG.dati_identificativi.localizzazione.citta.nome,''));

    if (event.type === 'conferma_selezione_amministrazione_oe')
    {
      submissionAux.summary_denominazione_oe =
        submissionAux.summary_denominazione_oe.split('list-group-item').join('list-group-item list-group-item-primary');
      submissionAux.cf_amministrazione_oe = "";
    }
    else
    {
      submissionAux.summary_cf_oe =
        submissionAux.summary_cf_oe.split('list-group-item').join('list-group-item list-group-item-primary');
      submissionAux.denominazione_amministrazione_oe = "";
    }
  }
  /* OPERATORE ECONOMICO */

  /* ENTE ANTICORRUZIONE */
  if (event.type === 'conferma_selezione_amministrazione_ente_anticorruzione' ||
      event.type === 'conferma_selezione_cf_ente_anticorruzione') {

    submissionAux.denominazione_ente_anticorruzione = this.clean(this.tmpPG.dati_identificativi.denominazione,'N.D.');
    submissionAux.codiceFiscale_ente_anticorruzione = this.clean(this.tmpPG.dati_identificativi.codice_fiscale,'N.D.');

    let regione =
      (await this.repository.getResponseWaitRegioneFromProvincia(
        this.tmpPG.dati_identificativi.localizzazione.provincia.nome,
        this.tmpPG.dati_identificativi.localizzazione.citta.nome,
        this.jwtToken));

    submissionAux.regione_ente_anticorruzione = regione.nome;

    submissionAux.provincia_ente_anticorruzione = this.titleCaseWord(this.clean(this.tmpPG.dati_identificativi.localizzazione.provincia.nome,''));
    submissionAux.comune_ente_anticorruzione = this.titleCaseWord(this.clean(this.tmpPG.dati_identificativi.localizzazione.citta.nome,''));

    if (event.type === 'conferma_selezione_amministrazione_ente_anticorruzione')
    {
      submissionAux.summary_denominazione_ente_anticorruzione =
        submissionAux.summary_denominazione_ente_anticorruzione.split('list-group-item').join('list-group-item list-group-item-primary');
      submissionAux.cf_amministrazione_ente_anticorruzione = "";
    }
    else
    {
      submissionAux.summary_cf_ente_anticorruzione =
        submissionAux.summary_cf_ente_anticorruzione.split('list-group-item').join('list-group-item list-group-item-primary');
      submissionAux.denominazione_ente_anticorruzione = "";
    }
}

if (event.type === 'cancella_campi_amministrazione_denominazione_anticorruzione')
{
  submissionAux.denominazione_ente_anticorruzione = "";
  submissionAux.summary_denominazione_ente_anticorruzione = "";
  submissionAux.regione_ente_anticorruzione = "";
  submissionAux.provincia_ente_anticorruzione = "";
  submissionAux.comune_ente_anticorruzione = "";
}

if (event.type === 'cancella_campi_amministrazione_cf_anticorruzione')
{
  submissionAux.cf_amministrazione_ente_anticorruzione = "";
  submissionAux.summary_denominazione_ente_anticorruzione = "";
  submissionAux.regione_ente_anticorruzione = "";
  submissionAux.provincia_ente_anticorruzione = "";
  submissionAux.comune_ente_anticorruzione = "";
}

/* ENTE ANTICORRUZIONE */

/* ENTE INCARICHI */
if (event.type === 'conferma_selezione_amministrazione_ente_incarichi' ||
event.type === 'conferma_selezione_cf_ente_incarichi') {

submissionAux.denominazioneente_incarichi = this.clean(this.tmpPG.dati_identificativi.denominazione,'N.D.');
submissionAux.cf_ente_incarichi = this.clean(this.tmpPG.dati_identificativi.codice_fiscale,'N.D.');

let regione =
(await this.repository.getResponseWaitRegioneFromProvincia(
  this.tmpPG.dati_identificativi.localizzazione.provincia.nome,
  this.tmpPG.dati_identificativi.localizzazione.citta.nome,
  this.jwtToken));

submissionAux.regione_ente_incarichi = regione.nome;

submissionAux.provincia_ente_incarichi = this.titleCaseWord(this.clean(this.tmpPG.dati_identificativi.localizzazione.provincia.nome,''));
submissionAux.comune_ente_incarichi = this.titleCaseWord(this.clean(this.tmpPG.dati_identificativi.localizzazione.citta.nome,''));

  if (event.type === 'conferma_selezione_amministrazione_ente_incarichi')
  {
    submissionAux.summary_denominazione_ente_incarichi =
      submissionAux.summary_denominazione_ente_incarichi.split('list-group-item').join('list-group-item list-group-item-primary');
    submissionAux.cf_amministrazione_ente_incarichi = "";
  }
  else
  {
    submissionAux.summary_cf_ente_incarichi =
      submissionAux.summary_cf_ente_incarichi.split('list-group-item').join('list-group-item list-group-item-primary');
    submissionAux.denominazione_amministrazione_ente_incarichi = "";
  }
}

/* ENTE INCARICHI */

/* ENTE TRASPARENZA */
if (event.type === 'conferma_selezione_amministrazione_ente_trasparenza' ||
event.type === 'conferma_selezione_cf_ente_trasparenza') {

submissionAux.denominazione_ente_trasparenza = this.clean(this.tmpPG.dati_identificativi.denominazione,'N.D.');
submissionAux.codiceFiscale_ente_trasparenza = this.clean(this.tmpPG.dati_identificativi.codice_fiscale,'N.D.');

let regione =
(await this.repository.getResponseWaitRegioneFromProvincia(
  this.tmpPG.dati_identificativi.localizzazione.provincia.nome,
  this.tmpPG.dati_identificativi.localizzazione.citta.nome,
  this.jwtToken));

submissionAux.regione_ente_trasparenza = regione.nome;

submissionAux.provincia_ente_trasparenza = this.titleCaseWord(this.clean(this.tmpPG.dati_identificativi.localizzazione.provincia.nome,''));
submissionAux.comune_ente_trasparenza = this.titleCaseWord(this.clean(this.tmpPG.dati_identificativi.localizzazione.citta.nome,''));

  if (event.type === 'conferma_selezione_amministrazione_ente_trasparenza')
  {
    submissionAux.summary_denominazione_ente_trasparenza =
      submissionAux.summary_denominazione_ente_trasparenza.split('list-group-item').join('list-group-item list-group-item-primary');
    submissionAux.cf_amministrazione_ente_trasparenza = "";
  }
  else
  {
    submissionAux.summary_cf_ente_trasparenza =
      submissionAux.summary_cf_ente_trasparenza.split('list-group-item').join('list-group-item list-group-item-primary');
    submissionAux.denominazione_amministrazione_ente_trasparenza = "";
  }
}

/* ENTE TRASPARENZA */


    if (event.type === 'valida_cig')
    {
      submissionAux.query_cig=0;
      submissionAux.cancella_cig=0;
      this.refreshForm.emit({
        // form: this.myform,
        submission: {
          data: submissionAux
        }
      });
      let response =  (await this.repository.getResponseWaitCig(event.data.cig,this.jwtToken));
      submissionAux.query_cig=1;


      this.refreshForm.emit({
        // form: this.myform,
        submission: {
          data: submissionAux
        }
      });

     if (response.codice_risposta==='NOKCN' || response.codice_risposta==='' || response==null)
        submissionAux.cig_trovato=1;
      else
      {
        // responsePG rappresenta il contenuto proveniente dalla seconda richiesta a ws per la pg
        let responsePG =
          (await this.repository.getResponseWaitPG(response.stazione_appaltante.CF_AMMINISTRAZIONE_APPALTANTE,this.jwtToken));

        let responseComune =
          (await this.repository.getResponseWaitComuneFromIstat(response.stazione_appaltante.ISTAT_COMUNE,this.jwtToken));
        let responseProvincia =
          (await this.repository.getResponseWaitProvinciaFromIstat(response.stazione_appaltante.ISTAT_COMUNE,this.jwtToken));
        let responseRegione =
          (await this.repository.getResponseWaitRegioneFromIstat(response.stazione_appaltante.ISTAT_COMUNE,this.jwtToken));

        submissionAux.cig_trovato=0;

        let aux = "<ul>";
        for (let data of responsePG.classificazioni) {
          aux = aux + "</li>"+data.codifica+"</li>";
        }
        aux = aux + "</ul>";

        let importoAux = "";
        if (response.bando.IMPORTO_COMPLESSIVO_GARA>0)
            importoAux = "euro "+response.bando.IMPORTO_COMPLESSIVO_GARA;

        submissionAux.sintesi_cig =  "<ul class='list-group list-group-flush'>"+
          "<li class='list-group-item'>"+`<b>${this.i18n.stazione_appaltante}</b> `+this.clean(response.stazione_appaltante.DENOMINAZIONE_AMMINISTRAZIONE_APPALTANTE,'N.D.')+"</li>"+
          "<li class='list-group-item'>"+`<b>${this.i18n.localizzazione}</b> `+this.clean(response.stazione_appaltante.CITTA+' ('+response.stazione_appaltante.REGIONE+')','N.D.')+"</li>"+
          "<li class='list-group-item'>"+`<b>${this.i18n.oggetto_gara}</b> `+this.clean(response.bando.OGGETTO_GARA,'N.D.')+"</li>"+
          "<li class='list-group-item'>"+`<b>${this.i18n.importo_complessivo}</b> `+this.clean(importoAux,'N.D.')+"</li>"+
          "</ul>";

        // i campi della stazione appaltante non devono essere modificabili
        submissionAux.codiceFiscale_sa=response.stazione_appaltante.CF_AMMINISTRAZIONE_APPALTANTE;
        submissionAux.denominazione_sa=response.stazione_appaltante.DENOMINAZIONE_AMMINISTRAZIONE_APPALTANTE;
        submissionAux.regione_appalti=this.titleCaseWord(responseRegione.nome);
        submissionAux.comune_appalti=this.titleCaseWord(responseComune.nome);
        submissionAux.provincia_appalti=this.titleCaseWord(responseProvincia.nome);

        for(let i=0; i<response.incaricati.length; i++){
          if (response.incaricati[i].COD_RUOLO==='14' && response.bando.TIPO_CIG==='ORDINARIO')
          {
            submissionAux.nome_rup=response.incaricati[i].NOME;
            submissionAux.cognome_rup=response.incaricati[i].COGNOME;
            break;
          }
          else if (response.incaricati[i].COD_RUOLO==='7' && response.bando.TIPO_CIG==='SMARTCIG')
          {
            submissionAux.nome_rup=response.incaricati[i].NOME;
            submissionAux.cognome_rup=response.incaricati[i].COGNOME;
            break;
          }
       }

        submissionAux.oggettoContratto_sa=response.bando.OGGETTO_GARA;

        if (response.bando.IMPORTO_COMPLESSIVO_GARA>0)
          submissionAux.importo_base_asta = response.bando.IMPORTO_COMPLESSIVO_GARA;
        else
          submissionAux.importo_base_asta = "";


        if (response.bando.COD_TIPO_SCELTA_CONTRAENTE)
        {
          let procedura_affidamento =
              await this.repository.getResponseWaitContraente(
                ""+response.bando.COD_TIPO_SCELTA_CONTRAENTE,
                this.jwtToken)
          if (procedura_affidamento.transcode)
            submissionAux.procedura_affidamento=procedura_affidamento.transcode
          else
            submissionAux.procedura_affidamento='altroTipoDiProcedura';
        }

        else submissionAux.procedura_affidamento='altroTipoDiProcedura';

        let modalitaAppalto = 1;
        if (response.bando.COD_MODALITA_REALIZZAZIONE)
          modalitaAppalto = response.bando.COD_MODALITA_REALIZZAZIONE;

          let modalita_realizzazione =
              await this.repository.getResponseWaitAmbito(
                ""+modalitaAppalto,
                response.bando.OGGETTO_PRINCIPALE_CONTRATTO,
                this.jwtToken)
          if (modalita_realizzazione)
            submissionAux.ambitodellintervento=modalita_realizzazione.transcode

        if (response.bando.MOTIVO_ESCLUSIONE)
        {
          if (response.bando.MOTIVO_ESCLUSIONE.includes("SECRETATI"))
            submissionAux.contrattoSecretato = 'si';
          else
            submissionAux.contrattoSecretato = 'no';
        }
      }
    }

    this.refreshForm.emit({
      // form: this.myform,
      submission: {
        data: submissionAux
      }
    });

  }

  private clean(val: string, nil: string)
  {
    if (val==='')
      return nil;
    else
      return val;
  }

  async onChange(event: any) {
    if (event.changed && event.changed.component.key === 'codiceIdentificativoGaraCig' && event.changed.value)  {
      if (event.changed.value.length < 10 || event.changed.value.length > 10)
      {
        event.data.query_cig_aggiuntivo = 0;
        this.refreshForm.emit({
          // form: this.myform,
          submission: {
            data: event.data
          }
        });
      }

      else if (event.changed.value.length === 10)

       {
        event.data.query_cig_aggiuntivo = 0;

        let response = (await this.repository.getResponseWaitCig(event.changed.value,this.jwtToken))
        let response_aux : string = "<b>CIG: "+event.changed.value+" - non presente in banca dati</b>";

        if (response.codice_risposta!=='NOKCN' && response.codice_risposta!=='' && response!=null)
        {
          response_aux =
          "<ul class='list-group list-group-flush'>"+
          "<li class='list-group-item'>"+`<b>${this.i18n.cig}</b> `+this.clean(event.changed.value,'N.D.')+"</li>"+
          "<li class='list-group-item'>"+`<b>${this.i18n.stazione_appaltante}</b> `+this.clean(response.stazione_appaltante.DENOMINAZIONE_AMMINISTRAZIONE_APPALTANTE,'N.D.')+"</li>"+
          "<li class='list-group-item'>"+`<b>${this.i18n.localizzazione}</b> `+this.clean(response.stazione_appaltante.CITTA+' ('+response.stazione_appaltante.REGIONE+')','N.D.')+"</li>"+
          "<li class='list-group-item'>"+`<b>${this.i18n.natura_giuridica}</b> `+this.clean(response.bando.OGGETTO_GARA,'N.D.')+"</li>"+
          "</ul>";
        }

        event.data.sintesi_cig_aggiuntivo = response_aux;
        event.data.query_cig_aggiuntivo = 1;

          this.refreshForm.emit({
            // form: this.myform,
            submission: {
              data: event.data
            }
          });
      }
    }

    if (event.changed && event.changed.component.key === 'selezione_ente' && event.changed.value)  {

      this.tmpPG = event.changed.value;

      let auxval = "<ul class='list-group list-group-flush'>"+
                   "<li class='list-group-item'>"+`<b>${this.i18n.denominazione}</b> `+this.clean(event.changed.value.dati_identificativi.denominazione,'N.D.')+"</li>"+
                   "<li class='list-group-item'>"+`<b>${this.i18n.cf}</b> `+this.clean(event.changed.value.dati_identificativi.codice_fiscale,'N.D.')+"</li>"+
                   "<li class='list-group-item'>"+`<b>${this.i18n.localizzazione}</b> `+
                   this.clean(event.changed.value.dati_identificativi.localizzazione.citta.nome + " (" +
                              event.changed.value.dati_identificativi.localizzazione.provincia.nome + ")",'N.D.')+"</li>"+
                   "<li class='list-group-item'>"+`<b>${this.i18n.natura_giuridica}</b> `+this.clean(event.changed.value.dati_identificativi.natura_giuridica.descrizione,'N.D.')+"</li>"+
                   "</ul>";

      event.data.summary_denominazione = auxval;

        this.refreshForm.emit({
          // form: this.myform,
          submission: {
            data: event.data
          }
        });
    }

    if (event.changed && event.changed.component.key === 'selezione_ente2' && event.changed.value)  {


      this.tmpPG = event.changed.value;

      let auxval = "<ul class='list-group list-group-flush'>"+
                   "<li class='list-group-item'>"+`<b>${this.i18n.denominazione}</b> `+this.clean(event.changed.value.dati_identificativi.denominazione,'N.D.')+"</li>"+
                   "<li class='list-group-item'>"+`<b>${this.i18n.cf}</b> `+this.clean(event.changed.value.dati_identificativi.codice_fiscale,'N.D.')+"</li>"+
                   "<li class='list-group-item'>"+`<b>${this.i18n.localizzazione}</b> `+
                   this.clean(event.changed.value.dati_identificativi.localizzazione.citta.nome + " (" +
                              event.changed.value.dati_identificativi.localizzazione.provincia.nome + ")",'N.D.')+"</li>"+
                   "<li class='list-group-item'>"+`<b>${this.i18n.natura_giuridica}</b> `+this.clean(event.changed.value.dati_identificativi.natura_giuridica.descrizione,'N.D.')+"</li>"+
                   "</ul>";

      event.data.summary_denominazione2 = auxval;

        this.refreshForm.emit({
          // form: this.myform,
          submission: {
            data: event.data
          }
        });
    }

    if (event.changed && event.changed.component.key === 'selezione_ente_oe' && event.changed.value)  {


      this.tmpPG = event.changed.value;

      let auxval = "<ul class='list-group list-group-flush'>"+
                   "<li class='list-group-item'>"+`<b>${this.i18n.denominazione}</b> `+this.clean(event.changed.value.dati_identificativi.denominazione,'N.D.')+"</li>"+
                   "<li class='list-group-item'>"+`<b>${this.i18n.cf}</b> `+this.clean(event.changed.value.dati_identificativi.codice_fiscale,'N.D.')+"</li>"+
                   "<li class='list-group-item'>"+`<b>${this.i18n.localizzazione}</b> `+
                   this.clean(event.changed.value.dati_identificativi.localizzazione.citta.nome + " (" +
                              event.changed.value.dati_identificativi.localizzazione.provincia.nome + ")",'N.D.')+"</li>"+
                   "<li class='list-group-item'>"+`<b>${this.i18n.natura_giuridica}</b> `+this.clean(event.changed.value.dati_identificativi.natura_giuridica.descrizione,'N.D.')+"</li>"+
                   "</ul>";

      event.data.summary_denominazione_oe = auxval;

        this.refreshForm.emit({
          // form: this.myform,
          submission: {
            data: event.data
          }
        });
    }

    if (event.changed && event.changed.component.key === 'selezione_ente_anticorruzione' && event.changed.value)  {


      this.tmpPG = event.changed.value;

      let auxval = "<ul class='list-group list-group-flush'>"+
                   "<li class='list-group-item'>"+`<b>${this.i18n.denominazione}</b> `+this.clean(event.changed.value.dati_identificativi.denominazione,'N.D.')+"</li>"+
                   "<li class='list-group-item'>"+`<b>${this.i18n.cf}</b> `+this.clean(event.changed.value.dati_identificativi.codice_fiscale,'N.D.')+"</li>"+
                   "<li class='list-group-item'>"+`<b>${this.i18n.localizzazione}</b> `+
                   this.clean(event.changed.value.dati_identificativi.localizzazione.citta.nome + " (" +
                              event.changed.value.dati_identificativi.localizzazione.provincia.nome + ")",'N.D.')+"</li>"+
                   "<li class='list-group-item'>"+`<b>${this.i18n.natura_giuridica}</b> `+this.clean(event.changed.value.dati_identificativi.natura_giuridica.descrizione,'N.D.')+"</li>"+
                   "</ul>";

      event.data.summary_denominazione_ente_anticorruzione = auxval;

        this.refreshForm.emit({
          // form: this.myform,
          submission: {
            data: event.data
          }
        });
    }

    if (event.changed && event.changed.component.key === 'selezione_ente_incarichi' && event.changed.value)  {


      this.tmpPG = event.changed.value;

      let auxval = "<ul class='list-group list-group-flush'>"+
                   "<li class='list-group-item'>"+`<b>${this.i18n.denominazione}</b> `+this.clean(event.changed.value.dati_identificativi.denominazione,'N.D.')+"</li>"+
                   "<li class='list-group-item'>"+`<b>${this.i18n.cf}</b> `+this.clean(event.changed.value.dati_identificativi.codice_fiscale,'N.D.')+"</li>"+
                   "<li class='list-group-item'>"+`<b>${this.i18n.localizzazione}</b> `+
                   this.clean(event.changed.value.dati_identificativi.localizzazione.citta.nome + " (" +
                              event.changed.value.dati_identificativi.localizzazione.provincia.nome + ")",'N.D.')+"</li>"+
                   "<li class='list-group-item'>"+`<b>${this.i18n.natura_giuridica}</b> `+this.clean(event.changed.value.dati_identificativi.natura_giuridica.descrizione,'N.D.')+"</li>"+
                   "</ul>";

      event.data.summary_denominazione_ente_incarichi = auxval;

        this.refreshForm.emit({
          // form: this.myform,
          submission: {
            data: event.data
          }
        });
    }

    if (event.changed && event.changed.component.key === 'selezione_ente_trasparenza' && event.changed.value)  {


      this.tmpPG = event.changed.value;

      let auxval = "<ul class='list-group list-group-flush'>"+
                   "<li class='list-group-item'>"+`<b>${this.i18n.denominazione}</b> `+this.clean(event.changed.value.dati_identificativi.denominazione,'N.D.')+"</li>"+
                   "<li class='list-group-item'>"+`<b>${this.i18n.cf}</b> `+this.clean(event.changed.value.dati_identificativi.codice_fiscale,'N.D.')+"</li>"+
                   "<li class='list-group-item'>"+`<b>${this.i18n.localizzazione}</b> `+
                   this.clean(event.changed.value.dati_identificativi.localizzazione.citta.nome + " (" +
                              event.changed.value.dati_identificativi.localizzazione.provincia.nome + ")",'N.D.')+"</li>"+
                   "<li class='list-group-item'>"+`<b>${this.i18n.natura_giuridica}</b> `+this.clean(event.changed.value.dati_identificativi.natura_giuridica.descrizione,'N.D.')+"</li>"+
                   "</ul>";

      event.data.summary_denominazione_ente_trasparenza = auxval;

        this.refreshForm.emit({
          // form: this.myform,
          submission: {
            data: event.data
          }
        });
    }

    if (event.changed && event.changed.component.key === 'cig' && event.changed.value)  {
       if (event.changed.value.length > 10) {
            event.data.ricerca_cig=1;
            event.data.cig=event.data.cig.substring(0, 10);

            this.refreshForm.emit({
              // form: this.myform,
              submission: {
                data: event.data
              }
            });
        }
      }
  }

  get submission() {
    return this.sub.getId();
  }

  setSubmission(id: any) {
    this.sub.setId(id);
  }

  async onSubmit(submission: any) {
      this.sub.setId(submission._id);
      this.sub.setSync(this.health.protocollo);
      this.router.navigate(['/end']);
  }

  resolved(captchaResponse: any) {
    if (captchaResponse) {
      this.captcha = true;
    }
  }

  onError(errorDetails: RecaptchaErrorParameters): void {
    this.captchaResponse += `ERROR; error details (if any) have been logged to console\n`;
    console.log(`reCAPTCHA error encountered; details:`, errorDetails);
  }

   onRender(form: any): any {
      form.options.hooks.beforeSubmit = this.handleBeforeSubmit.bind(this);
    }


   handleBeforeSubmit(submission: any, next: any) {
    if (!this.captcha)
      this.router.navigate(['/']);

     let message = "Si conferma l'invio del modulo?";
     let header = 'Conferma di invio';
     let accpetLabel = 'Si'
     if (this.languageService.lang.slice(0, 2) === 'en') {
       message = 'Confirm submission of the form?';
       header = 'Submission confirmation';
       accpetLabel = 'Yes';
     }

      this.confirmationService.confirm({
        message: message,
        header:  header,
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: accpetLabel,
        accept: () => {
            this.messageService.add({severity:'info', summary:'Confirmed', detail:'Accettato'});
            next('',submission);
        },
        reject: (type: any) => {
          next('non accettato',submission);
        }
    });


  }
}
